export const TOKEN = "tokenVeDi";
export const REFRESH_TOKEN = "refreshTokenVeDi";

export const SOLICITAR = "SOLICITAR";
export const ASIGNAR = "ASIGNAR";

export const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const ROL = "COMUNICADOR";
